export const environment = {
  production: false,
  hmr: false,
  // backendUrl: 'http://localhost:8080'
  backendUrl: 'https://crmt.ishayoga.live'
};
